export default "__VITE_ASSET__365c4904__"